import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ENVIRONMENTS_CONFIGURATION } from '@celerofinancas/ui-environments';
import {
  CORE_REGISTRY_CONFIG,
  ClearRequestInterceptor,
  CoreRegistryInterceptor,
  WithCredentialsInterceptor,
  XsrfInterceptor,
} from '@celerofinancas/ui-interceptors';
import { TokenRefreshInterceptor, httpHeadersInterceptor } from '@celerofinancas/ui-oauth';
import { environment } from '@environments/environment';
import { TokenRaceConditionInterceptor } from '@shared/interceptors/token-race.interceptor';
import { createCoreRegistryConfig } from './core-registry-config.factory';
import { sessionRecoveryInterceptor } from './session-recovery.interceptor';

/**
 * HTTP layer for the application: session (refresh plus the ui-oauth headers),
 * credentials/CSRF and the core registry bootstrap (in that order), followed by
 * request cleanup.
 */
export const INTERCEPTORS_LIST = [
  {
    provide: ENVIRONMENTS_CONFIGURATION,
    useValue: environment,
  },
  provideHttpClient(
    withInterceptorsFromDi(),
    // `sessionRecoveryInterceptor` closes the hole of the timer-driven refresh,
    // whose error `ui-oauth` swallows — see its own docblock.
    withInterceptors([httpHeadersInterceptor, sessionRecoveryInterceptor]),
  ),
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenRefreshInterceptor,
    multi: true,
  },
  // Has to sit before the ones that read the token: it is what guarantees there is
  // one. The screens call the API from `ngOnInit`, and the portal writes the `token`
  // attribute after the element is connected, so without this the first requests go
  // out unauthenticated. See the interceptor's own docblock.
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenRaceConditionInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: WithCredentialsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: XsrfInterceptor,
    multi: true,
  },
  {
    provide: CORE_REGISTRY_CONFIG,
    useFactory: createCoreRegistryConfig,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CoreRegistryInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ClearRequestInterceptor,
    multi: true,
  },
];
